<div *ngIf="!agregarHorarioValidacion">
  <div *ngIf="!esValidacion" class="d-flex justify-content-between align-items-center px-3 border-bottom border-light shadow-sm">
    <h2 class="modal-title mb-0 ms-2 fw-bold">Cubrir turno del dia {{ formatoFecha(incidenciaValidacion.fecha) }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="mx-3 mb-3">
    <h3 *ngIf="!esValidacion" class="mt-3 mb-0 fw-medium">Horario del empleado {{ incidenciaValidacion.nombre }}</h3>
    <app-horario-detalle [esCambioTurno]="true" [soloConsulta]="true" [horario]="horarioValidacion" [diaIncidencia]="diaIncidenciaValidacion"></app-horario-detalle>

    <hr class="border border-secondary">

    <div class="mb-2">
      <label class="mb-0 text-start">Selecciona el empleado con el que se cambiara de turno</label>
      <ng-select [items]="empleados" [(ngModel)]="empleadoSeleccionado" bindLabel="nombreCompleto" notFoundText="Empleado no encontrado" (ngModelChange)="obtenerHorario()" (clear)="limpiarFiltro()" appendTo="body" dropdownPosition="auto">
        <ng-template ng-option-tmp let-item="item">
          {{ nombreCompleto(item) }}
        </ng-template>
      </ng-select>
    </div>
    <div *ngIf="empleadoSeleccionado">
      <app-horario-detalle [esCambioTurno]="true" [soloConsulta]="true" [horario]="horarioSeleccionadoEmpleado" [diaIncidencia]="diaIncidenciaValidacion"></app-horario-detalle>
    </div>

    <div class="d-flex pt-2 justify-content-end" *ngIf="!esValidacion">
      <button mat-raised-button class="custom-button mx-1" (click)="aplicarCambioTurno()" [disabled]="!empleadoSeleccionado">Cambiar turno</button>
      <button mat-raised-button color="warn" mat-dialog-close>Cancelar</button>
    </div>
  </div>
</div>

<div *ngIf="agregarHorarioValidacion">
  <div class="d-flex justify-content-between align-items-center px-3 border-bottom border-light shadow-sm" *ngIf="data && incidenciaValidacion != undefined">
    <h2 class="modal-title mb-0 ms-2 fw-bold">Asignar nuevo horario a {{ incidenciaValidacion.nombre }}</h2>
    <button mat-dialog-close mat-icon-button><mat-icon>close</mat-icon></button>
  </div>

  <div [ngClass]="{'mx-4 my-3': data}">
    <app-horario-detalle (horarioEntradaEmit)="emitirHorarioEntrada($event)" (horarioSalidaEmit)="emitirHorarioSalida($event)" [modificarHorario]="true" [soloConsulta]="false" [horario]="horarioValidacion" [horarioEmpleado]="true" [diaIncidencia]="diaIncidenciaValidacion"></app-horario-detalle>
  </div>

  <div class="d-flex m-2 justify-content-end" *ngIf="data && incidenciaValidacion != undefined">
    <button mat-raised-button class="bg-success text-white" (click)="aplicarAsignarHorario()">Asignar horario</button>
    <button mat-raised-button mat-dialog-close class="bg-danger text-white mx-1">Cancelar</button>
  </div>
</div>
